import { Controller } from 'lib/stimulus-instance'
import ky, { HTTPError } from 'lib/ky'
import conversion from 'frontend/lib/conversion/conversion-set'

export default class SubscribeToNewsletterController extends Controller {
  static values = { path: String, list: String }
  static targets = ['inputField', 'spinner', 'error']
  static classes = ['base']

  async submit () {
    this.success = false
    this.working = true
    this.errorMessage = ''
    await new Promise(resolve => setTimeout(resolve, 1000))
    try {
      const subscriber = { email: this.inputFieldTarget.value }
      if (this.listValue) subscriber.list = this.listValue
      await ky.post(
        this.pathValue,
        { json: { newsletterSubscriber: subscriber } },
      ).json()
      this.working = false
      this.success = true
    } catch (error) {
      this.working = false
      if (error instanceof HTTPError) {
        const { errors } = await error.response.json()
        if (errors) {
          this.errorMessage = errors.join('; ')
        } else {
          this.errorMessage = 'Sorry, something went wrong.'
          throw (error)
        }
      } else {
        throw (error)
      }
    }

    conversion.push({ type: 'event', event: 'newsletter_signup' })
  }

  /**
   * @param {Boolean} value
   */
  set working (working) {
    this._working = working
    if (!this.hasSpinnerTarget) return
    if (working) {
      this.spinnerTarget.classList.add('is-visible')
      this.element.classList.add(`${this.baseClass}--working`)
    } else {
      this.spinnerTarget.classList.remove('is-visible')
      this.element.classList.remove(`${this.baseClass}--working`)
    }
  }

  get working () {
    return this._working
  }

  /**
   * @param {String} error
   */
  set errorMessage (error) {
    this.errorTarget.innerText = error
    if (error.length > 0) {
      this.errorTarget.classList.add('is-visible')
      this.element.classList.add(`${this.baseClass}--error`)
    } else {
      this.errorTarget.classList.remove('is-visible')
      this.element.classList.remove(`${this.baseClass}--error`)
    }
  }

  get errorMessage () {
    return this.errorTarget.innerText
  }

  /**
   * @param {String} success
   */
  set success (success) {
    this._success = success
    success && this.element.classList.add(`${this.baseClass}--success`)
    success || this.element.classList.remove(`${this.baseClass}--success`)
  }

  get success () {
    return this._success
  }
}
